import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import { IconDeviceFloppy, IconSquareX } from '@tabler/icons-react';
import { useParams } from 'react-router';
import SelectRegister from 'react-select';
import { validationAccess } from "../../../helpers/validationAccess"
import {
  getModule, setHrefWithSlugHook, getSlug
} from "../../../../src/config/routes/guards/slug";
import { useLocation } from 'react-router';
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const EditRiskManagementMonitoringReportComp = (props) => {
  //   console.log(props);
  const routeParams = useParams();

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [listRiskProfile, setlistRiskProfile] = useState(
    props?.editRiskManagementMonitoringReport?.listRiskProfile
  );
  const [idRiskProfile, setidRiskProfile] = useState({
    value: props?.editRiskManagementMonitoringReport?.risk_profile?.id,
    label: props?.editRiskManagementMonitoringReport?.risk_profile?.rootCause,
  });

  const [scoreAnalysis, setscoreAnalysis] = useState(
    props?.editRiskManagementMonitoringReport?.risk_profile?.risk_register
      ?.scoreAnalysis
  );
  const [scoreMonitoring, setscoreMonitoring] = useState(
    parseInt(
      props?.editRiskManagementMonitoringReport?.risk_bobot?.probabilityValue
    ) *
    (parseInt(
      props?.editRiskManagementMonitoringReport?.risk_bobot?.impactValue
    ) *
      parseFloat(
        props?.editRiskManagementMonitoringReport?.risk_bobot?.score
      ))
  );
  const [actionControl, setactionControl] = useState(
    props?.editRiskManagementMonitoringReport?.actionControl
  );
  // const [riskHandlingOutput, setriskHandlingOutput] = useState(
  //   props?.editRiskManagementMonitoringReport?.riskHandlingOutput
  // );
  // const [riskHandlingTarget, setriskHandlingTarget] = useState(
  //   props?.editRiskManagementMonitoringReport?.riskHandlingTarget
  // );
  // const [riskHandlingRealization, setriskHandlingRealization] = useState(
  //   props?.editRiskManagementMonitoringReport?.riskHandlingRealization
  // );

  const location = useLocation();
  const [role, setRole] = useState('');

  const fetchlistByFk = async () => {
    try {
      const options = {
        url: `/risk-profile/showByFk/${routeParams.id}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setlistRiskProfile([]);
      data.map((d) =>
        setlistRiskProfile((listRiskProfile) => [
          ...listRiskProfile,
          {
            label: d.rootCause,
            value: d.id,
          },
        ])
      );
    } catch (err) {
      setLoading(false);
      notifyApiLoadError(err, 'components/moleculs/risk-management-monitoring/edit-report.fetchlistByFk');
    }
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/risk-management-monitoring/edit-report.fetchOneUser');
    }
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook('/login');
        }, 3000);
      } else {
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook('/login');
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/risk-management-monitoring/edit-report.fetchLoginStatus');
    }
  };

  useEffect(() => {
    fetchlistByFk();
    fetchLoginStatus();
    fetchOneUser();
  }, []);

  const handleEditRiskManagementMonitoringReport = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      idRiskProfile: idRiskProfile?.value,
      actionControl: actionControl,
      // riskHandlingOutput: riskHandlingOutput,
      // riskHandlingTarget: riskHandlingTarget,
      // riskHandlingRealization: riskHandlingRealization,
    };
    // console.log(requestBody);
    // return false;
    axios({
      url: `/management-monitoring/report/${props?.editRiskManagementMonitoringReport?.id}`,
      method: 'PATCH',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res);
        // return false;
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully ubah laporan!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className="mb-5">
            <label htmlFor="name" className="form-label">
              Akar Masalah Risk Profile
            </label>
            <SelectRegister
              id="name"
              value={idRiskProfile}
              onChange={setidRiskProfile}
              isDisabled={true}
              options={listRiskProfile}
              placeholder="Cari rencana"
            />
          </div>
        </div>
        <div className="row">
          <h4>Komparasi Nilai Perolehan</h4>
          <hr className="my-2" />
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="scoreAnalysis" className="form-label">
              Nilai Risk Register
            </label>
            <input
              type="text"
              className="form-control row-cols-3"
              id="scoreAnalysis"
              onChange={(e) => setscoreAnalysis(e.target.value)}
              value={scoreAnalysis}
              disabled
            ></input>
          </div>
        </div>

        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="scoreMonitoring" className="form-label">
              Nilai Pemantauan
            </label>
            <input
              type="text"
              className="form-control row-cols-3"
              id="scoreMonitoring"
              onChange={(e) => setscoreMonitoring(e.target.value)}
              value={scoreMonitoring}
              disabled
            ></input>
          </div>
        </div>
        <hr className="my-2" />
      </div>

      <div className="row">
        <div className="col-12">
          <div className="mb-5">
            <label htmlFor="actionControl" className="form-label required">
              Aksi/Pengendalian
            </label>
            <textarea
              className="form-control row-cols-3"
              id="actionControl"
              onChange={(e) => setactionControl(e.target.value)}
              value={actionControl}
            ></textarea>
          </div>
        </div>
        {/* <div className="col-6">
          <div className="mb-5">
            <label htmlFor="riskHandlingOutput" className="form-label required">
              Output Penanganan Risiko
            </label>
            <textarea
              className="form-control row-cols-3"
              id="riskHandlingOutput"
              onChange={(e) => setriskHandlingOutput(e.target.value)}
              value={riskHandlingOutput}
            ></textarea>
          </div>
        </div> */}
      </div>

      {/* <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="riskHandlingTarget" className="form-label required">
              Target Penanganan Risiko
            </label>
            <textarea
              className="form-control row-cols-3"
              id="riskHandlingTarget"
              onChange={(e) => setriskHandlingTarget(e.target.value)}
              value={riskHandlingTarget}
            ></textarea>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label
              htmlFor="riskHandlingRealization"
              className="form-label required"
            >
              Realisasi Penanganan Risiko
            </label>
            <textarea
              className="form-control row-cols-3"
              id="riskHandlingRealization"
              onChange={(e) => setriskHandlingRealization(e.target.value)}
              value={riskHandlingRealization}
            ></textarea>
          </div>
        </div>
      </div> */}

      <div className="mt-5 row">
        <div className="d-flex flex-center flex-row-fluid pt-2">
          <Button
            disabled={disabled}
            variant="primary"
            size="sm"
            onClick={() => handleEditRiskManagementMonitoringReport()}
          >
            <IconDeviceFloppy stroke={2} />{' '}
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
          &nbsp;
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            <IconSquareX stroke={2} /> Tutup
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditRiskManagementMonitoringReportComp;
